import { Component } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { Observable, of } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { ToySafetyReport } from 'src/app/models/domain';
import { DesignService, ToySafetyReportService } from 'src/app/state';
import { environment } from 'src/environments/environment';

interface IToySafetyReportsState {
  reports: ToySafetyReport[];
  loading: boolean;
  error: string | undefined;
}

@Component({
  selector: 'em-toy-safety-report',
  templateUrl: './toy-safety-report.component.html',
  standalone: false,
})
export class ToySafetyReportComponent {
  public readonly state$: Observable<IToySafetyReportsState> = this.designService.designId$.pipe(
    switchMap((designId) =>
      this.toySafetyReportService.loadByDesignId(designId).pipe(
        map<ToySafetyReport[], IToySafetyReportsState>((reports) => ({
          reports,
          loading: false,
          error: undefined,
        })),
        startWith<IToySafetyReportsState>({ reports: [], loading: true, error: undefined }),
        catchError((error: { message?: string }) =>
          of<IToySafetyReportsState>({
            reports: [],
            loading: false,
            error: error.message ?? 'Failed to load toy safety reports',
          })
        )
      )
    )
  );

  public readonly isDesignLoading$ = this.designService.loading$;
  public readonly trackByRef = trackByRef;
  public readonly siteUrl = environment.sharePointTSRSiteUrl;
  public readonly toySafetyUrl = environment.toySafetyReportTool;

  public constructor(
    private readonly designService: DesignService,
    private readonly toySafetyReportService: ToySafetyReportService
  ) {}
}
